import { getUniqueId } from '@/editor/utils';
import { EEntityType } from '../types';
import { Box3 } from 'three';
import BaseModel2d from './2d/BaseModel2d';
import BaseModel3d from './3d/BaseModel3d';

export interface BaseEntityOptions<T = EEntityType.Base> {
  type?: T;
  id?: string;
  brandgoodId?: string;
}

class BaseEntity<T extends EEntityType = EEntityType.Base> {
  protected _id: string;
  protected _model2d: BaseModel2d | null = null;
  protected _model3d: BaseModel3d | null = null;
  protected _selected: boolean = false;
  protected _modelId: string;
  protected _type: T;

  protected _visible: boolean;

  // 交互属性
  protected interactive: boolean;
  protected hoverable: boolean;
  protected selectable: boolean;

  protected boundingBox: number[] = [0, 0, 0];

  constructor(options: BaseEntityOptions<T> = {}) {
    const { id, brandgoodId } = options;
    this._id = id || getUniqueId();
    this._visible = true;
    this.interactive = false;
    this.hoverable = false;
    this.selectable = false;
    this._modelId = brandgoodId || '';
    this._type = options.type ?? (EEntityType.Base as T);

    // const brandgoodInfo = globalStores.modelStore.getModel(this._modelId);
    // if (brandgoodInfo) {
    //   this.boundingBox = brandgoodInfo.boundingBox;
    // }
  }

  get id() {
    return this._id;
  }

  get type(): T {
    return this._type;
  }

  get selected() {
    return this._selected;
  }

  set selected(selected: boolean) {
    this._selected = selected;
  }

  load3dModel() {
    void this._model3d?.loadModel();
  }

  update(..._data: any[]) {}

  getBoundingBox() {
    if (!this._model2d) return new Box3();
    return this._model2d.getBoundingBox();
  }

  getBoundingBox3d() {
    if (!this._model3d) return new Box3();
    return this._model3d.getBoundingBox();
  }

  dispose() {
    this._model2d?.dispose();
    this._model3d?.dispose();
  }
}

export default BaseEntity;
